import React from "react";
import style from "./style.module.scss";
import Avatar from "../../../../../../components/Avatar/Avatar";
import DropDown from "../../../../../../components/DropDown/DropDown";
import Select from "../../../members/member/select";
import PhoneIcon from "../../../../../../assets/svg/icons/common/phone";
import MailIcon from "../../../../../../assets/svg/icons/common/mail";
import KebabDots16 from "../../../../../../assets/svg/icons/common/KebabDots16";

const ROLES = [
  { label: "Admin", value: "admin" },
  { label: "Agent", value: "agent" },
  { label: "Branch head", value: "branch head" },
  { label: "Office head", value: "office head" },
];

const AVAILABILITY = [
  { label: "Enabled", value: 0 },
  { label: "Disabled", value: 1 },
];

const getAvailabilityColor = (status) => {
  return status == 0 ? "#4CAF50" : "#400006";
};

function ChildTableRow({ data, lastRow, handleRemoveMember, updateMemberStatus }) {
const sub_org_drop_down_options = [
    {
      text: "Remove Member",
      type: "danger",
      onClick: () => {
        handleRemoveMember(data?.sub_org_id, data?.id);
      },
    }
  ];

  return (
    <tr className={`${style.line} ${!lastRow ? style.line_after : ""}`}>
      <td className={style.child_table_cell}>
        <div className={style.child_row_cell_container} >
          <span className={style.child_row_item} >
            <Avatar name="M" />
            {data?.name}
          </span>

          <span className={style.child_row_item} >
            <PhoneIcon />
            {data?.phone_direct}
          </span>

          <span className={style.child_row_item} >
            <MailIcon />
            {data?.name}
          </span>

        </div>
      </td>
      <td className={style.child_table_cell}>
          
            <span >{ROLES.find((r) => r.value == data?.role)?.label}</span>
          
            <Select
              value={data?.disabled}
              options={AVAILABILITY}
              onChange={(value) => updateMemberStatus(data, value)}
              indicatorColor={getAvailabilityColor(data?.disabled)}
            />
          

            <DropDown options={sub_org_drop_down_options}>
              <KebabDots16 />
            </DropDown>
      </td>
    </tr>
  );
}

export default ChildTableRow;
